import React, { useState } from 'react';
import { tr } from '../til';

// Mahkumning uyiga yo'l.
//
// Nima uchun kerak: viloyat apparati xodimi mahkumni inspektorga
// aytmasdan, qo'qqisdan tekshirishi mumkin — bu inspektor bilan mahkum
// til biriktirmaganini aniqlashning yagona yo'li. Bunda unga uyning
// manzili emas, aniq NUQTASI kerak: begona tumanda "Chinobod MFY,
// 12-uy" degan yozuv bilan uyni topib bo'lmaydi.
//
// Shuning uchun koordinata navigatorga to'g'ridan-to'g'ri uzatiladi.
// Inspektorning o'ziga ham foydasi bor: kunlik tashrifda adashib
// yurmaydi.
//
// Havola ochilganda telefonda Yandex yoki Google ilovasi o'zi ochiladi,
// kompyuterda esa brauzerda xarita chiqadi.

// Koordinata yo'q bo'lsa manzil matni bo'yicha qidiriladi — bu aniq
// emas, shuning uchun oynada ogohlantirish ko'rsatiladi.
const yandexYol = (lat, lon, manzil) => (lat != null && lon != null
  ? `https://yandex.uz/maps/?rtext=~${lat},${lon}&rtt=auto`
  : `https://yandex.uz/maps/?text=${encodeURIComponent(manzil || '')}`);

const googleYol = (lat, lon, manzil) => (lat != null && lon != null
  ? `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`
  : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(manzil || '')}`);

const yopish = {
  padding: '10px 24px', background: '#1a1a2e', color: '#fff', border: 'none',
  borderRadius: '8px', fontSize: '14px', cursor: 'pointer'
};

const havola = (rang) => ({
  display: 'block', textAlign: 'center', padding: '12px 16px', borderRadius: '10px',
  background: rang, color: '#fff', textDecoration: 'none', fontSize: '14px',
  fontWeight: 600
});

function YolKorsat({ mahkum, onYopish }) {
  const [nusxalandi, setNusxalandi] = useState(false);
  if (!mahkum) return null;

  const lat = mahkum.uy_lat == null ? null : Number(mahkum.uy_lat);
  const lon = mahkum.uy_lon == null ? null : Number(mahkum.uy_lon);
  const bor = lat != null && lon != null && !Number.isNaN(lat) && !Number.isNaN(lon);
  const nuqta = bor ? `${lat.toFixed(6)}, ${lon.toFixed(6)}` : '';

  const nusxala = () => {
    // Clipboard API faqat https da ishlaydi; ishlamasa matn ko'rinib
    // turadi va qo'lda ko'chirish mumkin.
    navigator.clipboard?.writeText(nuqta).then(
      () => { setNusxalandi(true); setTimeout(() => setNusxalandi(false), 2000); },
      () => {}
    );
  };

  return (
    <div onClick={onYopish} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: '#fff', borderRadius: '14px', padding: '22px',
        width: '100%', maxWidth: '420px'
      }}>
        <h3 style={{ margin: '0 0 4px', fontSize: '17px' }}>{tr("Uyga yo'l")}</h3>
        <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '2px' }}>
          {mahkum.familiya} {mahkum.ism} {mahkum.sharif || ''}
        </div>
        <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>
          {mahkum.manzil || tr("Manzil ko'rsatilmagan")}
        </div>

        {bor ? (
          <div style={{
            background: '#f5f7fb', borderRadius: '10px', padding: '10px 12px',
            marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '10px'
          }}>
            <code style={{ fontSize: '13px', flex: 1 }}>{nuqta}</code>
            <button onClick={nusxala} style={{
              padding: '6px 10px', fontSize: '12px', border: '1px solid #d7dbe6',
              background: '#fff', borderRadius: '7px', cursor: 'pointer'
            }}>
              {nusxalandi ? tr("Nusxalandi") : tr("Nusxalash")}
            </button>
          </div>
        ) : (
          <div style={{
            background: '#fff7e6', color: '#8a6d3b', borderRadius: '10px',
            padding: '10px 12px', marginBottom: '14px', fontSize: '12px'
          }}>
            {tr("Uy koordinatasi ko'rsatilmagan — xarita faqat manzil matni bo'yicha qidiradi va aniq bo'lmasligi mumkin.")}
          </div>
        )}

        <div style={{ display: 'grid', gap: '8px' }}>
          <a href={yandexYol(bor ? lat : null, bor ? lon : null, mahkum.manzil)}
            target="_blank" rel="noreferrer" style={havola('#d32f2f')}>
            {tr("Yandex navigatorda ochish")}
          </a>
          <a href={googleYol(bor ? lat : null, bor ? lon : null, mahkum.manzil)}
            target="_blank" rel="noreferrer" style={havola('#1976d2')}>
            {tr("Google xaritada ochish")}
          </a>
        </div>

        <div style={{ fontSize: '11px', color: '#999', marginTop: '12px' }}>
          {tr("Telefonda havola navigator ilovasini o'zi ochadi. Kompyuterda koordinatani nusxalab telefonga yuboring.")}
        </div>

        <div style={{ textAlign: 'right', marginTop: '16px' }}>
          <button onClick={onYopish} style={yopish}>{tr("Yopish")}</button>
        </div>
      </div>
    </div>
  );
}

export default YolKorsat;
